export default "__VITE_ASSET__0618e4d1__"